import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from '@ibk/shared-translation';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
import { useEmissorOrderDetails } from '../../../hooks/useEmissorOrderDetails';
import { useEmissorOrderPaymentPdf } from '../../../hooks/useEmissorOrderPaymentPdf';
import { EmissorOrderPaymentMethod } from '../../../services/contractOrderPaymentApi';
import { buildBoletoFilename, resolveOrderIdentifier } from '../../../utils/fileNamingUtils';
import { copyPaymentCode } from '../../../utils/rechargePaymentUtils';
export function useEmissorPaymentPixPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id: orderId = '' } = useParams();
    const { details, isLoading: isPageLoading } = useEmissorOrderDetails(orderId);
    const { getOrderPaymentPdf, isLoading: isPdfLoading } = useEmissorOrderPaymentPdf();
    const [alertData, setAlertData] = useState({ visible: false, message: '', type: 'success' });
    const [isAnnotationVisible, setIsAnnotationVisible] = useState(true);
    const readableCode = details?.readableCode ?? '';
    const orderTotalValue = details?.orderTotalValue ?? 0;
    const handleCopyCode = async () => {
        await copyPaymentCode({
            paymentCode: readableCode,
            setAlertData,
            t,
            translationKey: 'payment.pix.alerts.copied',
        });
    };
    const handleDownloadPdf = async () => {
        if (!details?.contractId || !orderId) {
            return;
        }
        try {
            const pdfBase64 = await getOrderPaymentPdf({
                contractId: details.contractId,
                orderId,
                paymentMethod: EmissorOrderPaymentMethod.PIX,
            });
            const filename = buildBoletoFilename(details.companyName, details.accrualPeriod, resolveOrderIdentifier(details.orderName, details.protocol));
            downloadBase64AsPDF(pdfBase64, filename);
        }
        catch {
            setAlertData({
                visible: true,
                message: t('payment.pix.alerts.pdfUnavailable'),
                type: 'error',
            });
        }
    };
    const handleCloseAnnotation = () => {
        setIsAnnotationVisible(false);
    };
    const handleGoToBenefits = () => {
        navigate('/beneficios');
    };
    return {
        readableCode,
        orderTotalValue,
        isPageLoading,
        hasPaymentData: Boolean(readableCode),
        alertData,
        isAnnotationVisible,
        isPdfLoading,
        setAlertData,
        handleCopyCode,
        handleDownloadPdf,
        handleCloseAnnotation,
        handleGoToBenefits,
    };
}
